const common = {
    pickDateRange: '期間を選択',
    required: '必須',
    backToDashboard: 'ダッシュボードに戻る',
    confirm: '確認',
    remove: '削除',
    pickDate: '日付を選択',
    clear: 'クリア',
    loading: '読み込み中...',
    error: 'エラー',
    save: '保存',
    cancel: 'キャンセル',
    add: '追加',
    update: '更新',
    delete: '削除',
    deleting: '削除中...',
    edit: '編集',
    view: '表示',
    download: 'ダウンロード',
    upload: 'アップロード',
    share: '共有',
    search: '検索',
    filter: 'フィルター',
    sort: '並び替え',
    actions: 'アクション',
    close: '閉じる',
    closeDialog: 'ダイアログを閉じる',
    breadcrumb: 'パンくずリスト',
    breadcrumbMore: '省略された階層',
    pagination: 'ページネーション',
    apply: '適用',
    clearAll: 'すべてクリア',
    retry: '再試行',
    pageRenderFailed: '画面を表示できませんでした',
    pageRenderFailedHint: '一時的な表示エラーが発生しました。再試行しても続く場合は、発生時刻とブラウザ名を管理者へお知らせください。',
    select: '選択',
    selectAll: 'すべて選択',
    moreCount: '+{{count}}件',
    noData: 'データがありません',
    noResults: '該当する結果がありません',
    all: 'すべて',
    more: 'もっと見る',
    less: '閉じる',
    important: '重要',
    language: '言語',
    goHome: 'ホームへ',
    refresh: '更新',
    enabled: '有効',
    disabled: '無効',
    currentSession: '現在のセッション',
    lastActivity: '最終アクティビティ',
    expires: '有効期限',
    registeredAt: '登録日',
    lastUsed: '最終使用',
    noGroups: 'グループなし',
    unknown: '不明',
    dateUnknown: '日付不明',
    userInfoNotAvailable: 'ユーザー情報を取得できませんでした。再度ログインしてください。',
    rowsPerPage: '表示件数',
    expand: '展開',
    collapse: '折りたたむ',
  };

export default common;
